import Auth from '../utils/Auth';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import * as ApiCall from '../apiCalls/users/userApiCalls';
import { UserPermissionEntityBreakdown } from '../types/api/users/UserPermissionEntityBreakdown';

const auth = new Auth();

export enum AccountActionTypes {
    ACCOUNT_LOGOUT = 'ACCOUNT_LOGOUT',
    ACCOUNT_LOGIN_SUCCESS = 'ACCOUNT_LOGIN_SUCCESS',
    ACCOUNT_PERMISSIONS_REQUEST_SUCCESS = 'ACCOUNT_PERMISSIONS_REQUEST_SUCCESS'
}

export type AccountAction =
    | ReturnType<typeof logoutAction>
    | ReturnType<typeof requestLoginSuccess>
    | ReturnType<typeof requestPermissionsSuccess>;
    

function logoutAction() {
    return {
        type: AccountActionTypes.ACCOUNT_LOGOUT
    } as const;
}


function requestLoginSuccess(accessToken: string) {
    return {
        type: AccountActionTypes.ACCOUNT_LOGIN_SUCCESS,
        payload: accessToken
    } as const;
}

function requestPermissionsSuccess(permissions: readonly UserPermissionEntityBreakdown[]) {
    return {
        type: AccountActionTypes.ACCOUNT_PERMISSIONS_REQUEST_SUCCESS,
        payload: permissions
    } as const;
}


export function fetchLogin() {
    auth.login();
}

export function authenticateAccount() {
    // This promise stuff is BS, but the code relying on it isn't TS, so won't update it yet.
    return (dispatch: ReduxDispatch) => {
        return new Promise(resolve => {
            const access_token = localStorage.getItem('access_token')!;
            dispatch(requestLoginSuccess(access_token));
            resolve(true);
        });
    };
}


export function fetchUserPermissions() {
    return async (dispatch: ReduxDispatch) => {
        const permissions = await ApiCall.getUserPermissions();
        dispatch(requestPermissionsSuccess(permissions));
        return true;
    };
}

export function handleAuthentication() {
    return async (dispatch: ReduxDispatch) => {
        const authResult = await auth.handleAuthentication();
        if (authResult) {
            // Not null assertion because we "know" the tokens "have" to be in local storage at this point.
            // This isn't ideal, but it's something.
            const access_token = localStorage.getItem('access_token')!;
            dispatch(requestLoginSuccess(access_token));
            return true;
        }
        else {
            auth.login();
        }
    };
}

export function logout() {
    return (dispatch: ReduxDispatch) => {
        auth.logout();
        dispatch(logoutAction());
    };
}

export function isAuthenticated() {
    return auth.isAuthenticated();
}